module.exports = __webpack_public_path__ + "media/src/images/mails/ffcc00-31fce014be8901fa874e7d11c3c8140a.png";